import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order, OrdersService } from '@compumark/order-management-client';

import { sanitizeInput } from '../../shared/sanitize.util';
import { UpdateOrderModel } from '../models/update-order-model';

@Component({
  selector: 'app-reference-info',
  templateUrl: './reference-info.component.html',
  styleUrls: ['./reference-info.component.scss'],
  standalone: false,
})
export class ReferenceInfoComponent implements OnInit, AfterViewInit {
  data = inject<{
    model: UpdateOrderModel;
  }>(MAT_DIALOG_DATA);
  private formBuilder = inject(FormBuilder);
  orderService = inject(OrdersService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  public order: Order;
  public referenceInfoForm!: FormGroup;
  public assignees: Set<string> = new Set<string>();
  public textAreaMaxlength = 2000;
  public defaultAssigneeValue = 'unassigned';
  private viewInitialized = false;

  constructor() {
    this.order = this.data.model.order!;
  }

  remainingCharacters(value: string): number {
    return this.textAreaMaxlength - value.length;
  }
  ngOnInit(): void {
    this.orderService.assignees().subscribe((assignees) => {
      this.assignees = assignees;
      if (this.viewInitialized) {
        this.changeDetectorRef.detectChanges();
      }
    });

    this.referenceInfoForm = this.formBuilder.group({
      assignee: [
        this.order.assignee! ? this.order.assignee! : this.defaultAssigneeValue,
      ],
      poNumber: [this.order.poNumber!],
      reference: [this.order.clientReference!],
      subClientReference: [this.order.subClientReference!],
      freeText: [this.order.freeText!],
      additionalInstruction: [this.order.additionalInstruction!],
    });
    this.changeOrderModel();
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
  }

  private changeOrderModel = () => {
    this.referenceInfoForm
      .get('assignee')
      ?.valueChanges.subscribe((value) => (this.order.assignee = value));

    this.referenceInfoForm
      .get('poNumber')
      ?.valueChanges.subscribe(
        (value) => (this.order.poNumber = sanitizeInput(value)),
      );

    this.referenceInfoForm
      .get('reference')
      ?.valueChanges.subscribe(
        (value) => (this.order.clientReference = sanitizeInput(value)),
      );

    this.referenceInfoForm
      .get('subClientReference')
      ?.valueChanges.subscribe(
        (value) => (this.order.subClientReference = sanitizeInput(value)),
      );

    this.referenceInfoForm
      .get('freeText')
      ?.valueChanges.subscribe(
        (value) => (this.order.freeText = sanitizeInput(value)),
      );

    this.referenceInfoForm
      .get('additionalInstruction')
      ?.valueChanges.subscribe(
        (value) => (this.order.additionalInstruction = sanitizeInput(value)),
      );
  };

  sanitizeFields(controlName: string): void {
    const control = this.referenceInfoForm.get(controlName);
    if (!control) {
      return;
    }
    const sanitized = sanitizeInput(control.value ?? '');
    if (sanitized !== control.value) {
      control.setValue(sanitized, { emitEvent: false });
    }
  }
}
